import { ReactNode } from "react";

import { config } from "@/config/base";

const RESUME_ADDRESS = import.meta.env.VITE_WEBSITE_ADDRESS;

const STYLES = {
  footerText: {
    color: "#000000"
  },
  footerLink: {
    color: "#0068B8"
  }
} as const;

interface AuthLayoutProps {
  children: ReactNode;
  footerContent?: ReactNode;
}

export const AuthLayout = ({ children, footerContent }: AuthLayoutProps) => {
  return (
    <div
      className="relative flex min-h-screen w-full items-center justify-center bg-cover bg-center p-4"
      style={{ backgroundImage: `url(${config.login.background})` }}
    >
      <Overlay />
      <AuthCard footerContent={footerContent}>{children}</AuthCard>
    </div>
  );
};

const Overlay = () => (
  <div
    className="absolute inset-0"
    style={{ backgroundColor: "rgba(27, 27, 27, 0.5)" }}
  />
);

interface AuthCardProps {
  children: ReactNode;
  footerContent?: ReactNode;
}

const AuthCard = ({ children, footerContent }: AuthCardProps) => (
  <div
    className="relative z-10 flex w-full max-w-[450px] flex-col"
    style={{
      minHeight: "440px",
      borderRadius: "20px"
    }}
  >
    <MainCard footerContent={footerContent}>
      <LogoSection />
      <FormSection>{children}</FormSection>
    </MainCard>
    {footerContent && <Footer>{footerContent}</Footer>}
  </div>
);

interface MainCardProps {
  children: React.ReactNode;
  footerContent?: React.ReactNode;
}

const MainCard = ({ children, footerContent }: MainCardProps) => (
  <div
    className="relative flex-1 bg-white px-6 py-8 sm:px-12 sm:py-10"
    style={{
      borderRadius: footerContent ? "20px 20px 0 0" : "20px"
    }}
  >
    {children}
  </div>
);

const LogoSection = () => (
  <div className="mb-4 flex items-center justify-center sm:mb-8">
    <img
      src={config.appConfig.images.uiLogo}
      alt={config.appConfig.texts.logoAlt}
      className="h-full w-auto object-contain"
      style={{
        filter: "drop-shadow(0px 10px 10px rgba(0, 0, 0, 0.25))",
        maxWidth: "285px"
      }}
    />
  </div>
);

const FormSection = ({ children }: { children: React.ReactNode }) => (
  <div className="mx-auto w-full max-w-[348px]">{children}</div>
);

const Footer = ({ children }: { children: React.ReactNode }) => (
  <div
    className="flex flex-col items-center justify-center gap-2 px-4 py-4 sm:gap-3 sm:py-5"
    style={{
      background: "#F2F2F2",
      borderRadius: "0 0 20px 20px",
      minHeight: "87px"
    }}
  >
    {children}
  </div>
);

// Footer Components که می‌توانند استفاده شوند
export const ResumeLink = () => (
  <a
    href={RESUME_ADDRESS}
    target="_blank"
    rel="noopener noreferrer"
    className="text-center font-normal transition-opacity hover:opacity-80 sm:text-sm"
    style={STYLES.footerText}
  >
    {config.appConfig.texts.loginSystemLink}{" "}
    <span className="mx-1 font-bold">{config.appConfig.texts.fullProfileTitle}</span>
  </a>
);

interface ForgotPasswordLinkProps {
  onClick: () => void;
}

export const ForgotPasswordLink = ({ onClick }: ForgotPasswordLinkProps) => (
  <button
    onClick={onClick}
    className="text-center text-sm font-normal transition-colors hover:underline"
    style={STYLES.footerLink}
  >
    فراموشی رمز عبور
  </button>
);
